
import Vue from 'vue';
import selectOnShift from "@/utils/selectOnShift";
import { store } from '@/store';
import { M_MENU } from '@/store/mutations-types';
import { columns } from '@/utils/columns';
import Grid from '@/components/Grid.vue';
import api from '@/api/api';
import ServicosControleHorasForm from './ServicosControleHorasForm.vue';
import ModalCrud from '@/components/ModalCrud.vue';
import type { IReturnXlsxExport } from '@/types/IServicosControleHoras';

export default Vue.extend({
    name: 'ServicosControleHoras',
    data() {
        return {
            table: {
                isLoading: false,
                dataset: [],
                gridItemsActions: [
                    {
                        label: 'Alterar',
                        action: 'update',
                        icon: 'mdi-pencil',
                        color: 'primary',
                        display: true,
                        loading: false
                    },
                    {
                        label: 'Ver Serviços',
                        action: 'see-service',
                        icon: 'mdi-eye',
                        color: 'purple accent-4',
                        display: true,
                        loading: false
                    },
                    {
                        label: 'Comissões',
                        action: 'comissoes',
                        icon: 'mdi-account-cash-outline',
                        color: 'green lighten-1',
                        display: true,
                        loading: false
                    }

                ]
            },
            modals: {
                criarEditarLancamento: {
                    isOpened: false
                },
                modalFiltros: {
                    isOpen: false,
                    isLoading: false,
                },
                verServico: {
                    isOpened: false
                }
            },
            forms: {
                filtrarLancamentos: {
                    controls: {
                        isValid: true
                    },
                    datasets: {
                        status: [],
                        responsavel: [],
                        clientes: [],
                        saldo: [
                            {
                                id: 'all',
                                label: 'Todos'
                            },
                            {
                                id: 'withBalance',
                                label: 'Com Saldo'
                            },
                            {
                                id: 'noBalance',
                                label: 'Sem Saldo'
                            },
                        ],
                        monitorado: [
                            {
                                id: 'all',
                                label: 'Todos'
                            },
                            {
                                id: 'isMonitored',
                                label: 'Monitorado'
                            },
                            {
                                id: 'noMonitored',
                                label: 'Não monitorado'
                            },
                        ],
                        monitoradoAdm: [
                            {
                                id: 'all',
                                label: 'Todos'
                            },
                            {
                                id: 'isMonitored',
                                label: 'Monitorado'
                            },
                            {
                                id: 'noMonitored',
                                label: 'Não monitorado'
                            },
                        ]
                    },
                    data: {
                        idStatus: [1, 2],
                        idCliente: [],
                        idResponsavel: [],
                        saldo: 'all',
                        monitorado: 'all',
                        monitoradoAdm: 'all',
                        dataInicioStart: '',
                        dataInicioEnd: ''
                    }
                }
            },
            selectedId: null
        }
    },
    async mounted() {
        await this.loadData();
    },
    methods: {
        async loadData() {
            try {
                this.table.isLoading = true;
                this.modals.modalFiltros.isLoading = true;
                const { data } = await api.get('/service-time-control?typeReq=grid&' + this.gerarQueryString());
                this.table.dataset = data;
                store.commit(M_MENU, "Controle de Serviços");
                this.forms.filtrarLancamentos.datasets.responsavel = [];
                this.forms.filtrarLancamentos.datasets.status = [];
                this.modals.modalFiltros.isOpen = false;
            } catch (err) {
                console.log(err)
                this.$toast.error(err.message ?? 'Falha ao comunicar com o back-end!');
            } finally {
                this.modals.modalFiltros.isLoading = false;
                this.table.isLoading = false;
            }
        },
        gerarQueryString() {
            const query = Object.keys(this.forms.filtrarLancamentos.data)
                .filter(key => this.forms.filtrarLancamentos.data[key] !== '' && this.forms.filtrarLancamentos.data[key] !== null && this.forms.filtrarLancamentos.data[key] !== undefined && this.forms.filtrarLancamentos.data[key].length > 0)
                .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.forms.filtrarLancamentos.data[key]))
                .join('&');

            return query;
        },
        async handleModalFilter() {
            try {
                this.table.isLoading = true;
                this.modals.modalFiltros.isLoading = true;
                this.modals.modalFiltros.isOpen = true;
                const { data } = await api.get('/service-time-control?typeReq=form');

                this.forms.filtrarLancamentos.datasets.clientes = data.dataset.clientes;
                this.forms.filtrarLancamentos.datasets.responsavel = data.dataset.colaboradores;
                this.forms.filtrarLancamentos.datasets.status = data.dataset.status;
            } catch (err) {
                console.log(err)
                this.$toast.error(err.message ?? 'Falha ao comunicar com o back-end!');
            } finally {
                this.modals.modalFiltros.isLoading = false;
                this.table.isLoading = false;
            }
        },
        handleGridItemsActions: function (action, item) {
            switch (action) {
                case 'update':
                    this.selectedId = item.id;
                    this.modals.criarEditarLancamento.isOpened = true;
                    break;
                case 'see-service':

                    this.$router.push({
                        path: `/controle-servicos/${item.id}`,
                    })

                    break;
                case 'comissoes':
                    if (this.$store.state.infoUser.current.supervisor || this.$store.state.infoUser.current.id === item.userId || this.$store.state.infoUser.current.departamento === 4) {
                        this.$router.push({
                            path: `/controle-servicos/comissoes/${item.id}`,
                        })
                    } else {
                        this.$toast.warning("Você não permissão para visualizar as comissões!")
                    }
                    break;
                default:
                    this.$toast.error('Opção de ação inválida!');
            };
        },
        handleModal: async function (operation) {
            if (operation === 'close') {
                this.modals.criarEditarLancamento.isOpened = false;
                this.selectedId = null;
                await this.loadData();
            };
            if (operation === 'open') {
                this.selectedId = null;
                this.modals.criarEditarLancamento.isOpened = true;
            }
        },
        handleXlsxExport: async function () {
            try {
                this.$store.state.loading = true;
                const { data } = await api.get<IReturnXlsxExport[]>('/service-time-control?typeReq=export&' + this.gerarQueryString());

                const { XlsxExport } = await import('@/utils/xlsxExport');

                let instanceExport = new XlsxExport({
                    columns: [
                        {
                            label: "ID Lote",
                            name: "ID_LOTE",
                        },
                        {
                            label: "Responsável Lote",
                            name: "RESPONSAVEL_LOTE",
                        },
                        {
                            label: "Cliente Lote",
                            name: "CLIENTE_LOTE",
                        },
                        {
                            label: "Qtd. Horas Lote",
                            name: "QTD_HORAS_LOTE",
                            isHourMin: true,
                        },
                        {
                            label: "Saldo Horas Lote",
                            name: "SALDO_HORAS_LOTE",
                            isHourMin: true,
                        },
                        {
                            label: "Data Início Lote",
                            name: "DATA_INICIO_LOTE",
                            isDate: true,
                        },
                        {
                            label: "Status Lote",
                            name: "STATUS_LOTE",
                        },
                        {
                            label: "Observação Lote",
                            name: "OBSERVACAO_LOTE",
                        },
                        {
                            label: "Responsável Lcto",
                            name: "RESPONSAVEL_MOV",
                        },
                        {
                            label: "Ticket Lcto",
                            name: "TICKET_MOV",
                        },
                        {
                            label: "Qtd. Horas Lcto",
                            name: "QTD_HORAS_MOV",
                            isHourMin: true,
                        },
                        {
                            label: "Data Início Lcto",
                            name: "DATA_INICIO_MOV",
                            isDate: true,
                        },
                        {
                            label: "Data Fim Lcto",
                            name: "DATA_FIM_MOV",
                            isDate: true,
                        },
                        {
                            label: "Descrição Lcto",
                            name: "DESCRICAO_MOV",
                        },
                        {
                            label: "Baixa Saldo Lcto",
                            name: "BAIXA_SALDO_MOV",
                        },
                        {
                            label: "Monitorado Lcto",
                            name: "TICKET_MONITORADO_MOV",
                        },
                        {
                            label: "Data Monitoramento Lcto",
                            name: "DATA_MONITORAMENTO_MOV",
                            isDate: true,
                        },
                        {
                            label: "Monitorado ADM Lcto",
                            name: "TICKET_MONITORADO_ADM_MOV",
                        },
                        {
                            label: "Data Monitoramento ADM Lcto",
                            name: "DATA_MONITORAMENTO_ADM_MOV",
                            isDate: true,
                        },
                    ],
                    data,
                    title: `Controle Serviços Lotes`
                });

                await instanceExport.export();
                instanceExport = null;
            } catch (error) {
                this.$toast.error(error.message ?? 'Falha na comunicação');
            } finally {
                this.$store.state.loading = false;
            }
        },
		selectOnShift
    },
    components: {
        Grid,
        ServicosControleHorasForm,
        ModalCrud
    },
    setup() {
        return {
            columns
        }
    }
})

